module.exports = __webpack_public_path__ + "img/weather.1ea61987.svg";